import { useState, useEffect } from 'react';
import { fetchQuestionnaires } from '../services/questionnaireService';
import { toast } from 'react-toastify';

const useFetchQuestionnaires = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getQuestionnaires = async () => {
      try {
        const questionnaires = await fetchQuestionnaires();
        setData(questionnaires);
      } catch (err) {
        const errorMessage = err.response?.status === 401 
          ? 'دسترسی غیرمجاز: لطفاً دوباره امتحان کنید.' 
          : err.message || 'خطا در دریافت پرسشنامه‌ها';
        setError(errorMessage);
        toast.error(errorMessage); 
      } finally {
        setLoading(false);
      }
    };

    getQuestionnaires();
  }, []);

  return { data, loading, error };
};

export default useFetchQuestionnaires;